window.fillCartReviewCounts = function () {
  var SUPABASE_URL = "https://gbfaazkjmkuqkifexivw.supabase.co";
  var SUPABASE_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdiZmFhemtqbWt1cWtpZmV4aXZ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNTE1MTAsImV4cCI6MjA5MjgyNzUxMH0.OSR5bzmgSJWJffu377ypnSrPmkRTP94gXeeIolod9ps";

  var groups = [];
  $(".add-one_rating_count[data-product-group]").each(function () {
    var g = $(this).data("product-group");
    if (g && groups.indexOf(g) === -1) groups.push(g);
  });
  if (!groups.length) return;

  $.ajax({ 
    url:
      SUPABASE_URL +
      "/rest/v1/product_group_review_counts?product_group=in.(" +
      groups.join(",") +
      ")&select=product_group,review_count",
    headers: { apikey: SUPABASE_KEY, Authorization: "Bearer " + SUPABASE_KEY },
  }).then(function (data) {
    var map = {};
    $.each(data, function (_, row) {
      map[row.product_group] = row.review_count;
    });
    var countLabel = (window.reviewStrings && window.reviewStrings.countLabel) || $(".reviews-pdp-dynamic-copies").data("count-label") || "";
    $(".add-one_rating_count[data-product-group]").each(function () {
      var count = map[$(this).data("product-group")];
      if (count !== undefined) {
        var countText = countLabel ? countLabel.replace("[count]", count) : count;
        $(this).find(".main_product_rating_actual__js_carted, .main_product_rating_actual__js").html("(" + countText + ")");
      }
    });
  });
};

$(document).ready(function () {
  fillCartReviewCounts();
});
